module.exports = __webpack_public_path__ + "img/phones.64595700.png";